export const websocketUrl = (() => {
  if (import.meta.env.PROD) {
    if (import.meta.env.REACT_APP_WEBSOCKET_API_URL) {
      // eslint-disable-next-line no-restricted-globals
      const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
      const path = import.meta.env.REACT_APP_WEBSOCKET_API_URL as string;
      return `${protocol}//${window.location.hostname}/${path}`;
    } else {
      throw Error('env REACT_APP_WEBSOCKET_API_URL not presents');
    }
  } else {
    // eslint-disable-next-line no-restricted-globals
    const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';
    const path = '/broadcast';
    // eslint-disable-next-line no-restricted-globals
    return `${protocol}//localhost${path}`;
  }
})();
